import React from "react";
import { useNavigate } from "react-router-dom";
import StatsTable from "./components/statsTable";

import ProfilePicture from "./components/profilePicture";
import { sortByWinAndLoss } from "./utils";

type Props = {
  currentPlayerName: string;
  games: any;
};

const PartnerTable = ({ currentPlayerName, games }: Props) => {
  const navigate = useNavigate();

  var partners: { [key: string]: { win_count: number; lose_count: number } } = {};

  for (var key in games) {
    var game = games[key];

    var partner = null;
    var currentPlayerTeam = null;

    // Check if the current player is in team_blue
    for (const player in game.team_blue) {
      if (player === currentPlayerName) {
        currentPlayerTeam = "blue";
        break;
      }
    }

    // Check if the current player is in team_red
    if (!currentPlayerTeam) {
      for (const player in game.team_red) {
        if (player === currentPlayerName) {
          currentPlayerTeam = "red";
          break;
        }
      }
    }

    // Determine if the current player's team won
    var teamWon = game.winner.toLowerCase() === currentPlayerTeam;

    // Process partners
    if (currentPlayerTeam === "blue") {
      for (const player in game.team_blue) {
        if (player !== currentPlayerName) {
          partner = player;
          if (partner in partners) {
            partners[partner].win_count += teamWon ? 1 : 0;
            partners[partner].lose_count += teamWon ? 0 : 1;
          } else {
            partners[partner] = {
              win_count: teamWon ? 1 : 0,
              lose_count: teamWon ? 0 : 1,
            };
          }
        }
      }
    } else if (currentPlayerTeam === "red") {
      for (const player in game.team_red) {
        if (player !== currentPlayerName) {
          partner = player;
          if (partner in partners) {
            partners[partner].win_count += teamWon ? 1 : 0;
            partners[partner].lose_count += teamWon ? 0 : 1;
          } else {
            partners[partner] = {
              win_count: teamWon ? 1 : 0,
              lose_count: teamWon ? 0 : 1,
            };
          }
        }
      }
    }
  }

  const sortedPartners = sortByWinAndLoss(partners);

  const profileOnClicked = (name: string) => {
    window.scrollTo(0, 0);
    navigate(`/players/${name}`)
  };

  return (
    <StatsTable header={"Partners"} leftColumn={"Partner"}>
      {sortedPartners.map(([partner, stats]) => (
        <tr key={partner}>
          <td className="profile-cell" onClick={() => profileOnClicked(partner)}>
            <ProfilePicture
              playerName={partner}
            />
          </td>
          <td>{stats.win_count}</td>
          <td>{stats.lose_count}</td>
          <td>
            {(
              (stats.win_count /
                (stats.win_count + stats.lose_count)) *
              100
            ).toFixed(0)}
            %
          </td>
        </tr>
      ))}
    </StatsTable>
  );
};
export default PartnerTable;
